/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-compatible version of Company
 * Ensures all fields are simple types that TSOA can serialize
 */
export type TCCompany = {
    name?: string | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    id: number;
    tenantId: string;
    sector?: string | null;
    /**
     * Client type - simplified as string
     */
    clientType: TCCompany.clientType;
};
export namespace TCCompany {
    /**
     * Client type - simplified as string
     */
    export enum clientType {
        GENERAL = 'GENERAL',
        REAL_ESTATE = 'REAL_ESTATE',
    }
}

